import { render, staticRenderFns } from "./ContactDetailsEdit.vue?vue&type=template&id=039e7ea2"
import script from "./ContactDetailsEdit.vue?vue&type=script&lang=js"
export * from "./ContactDetailsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports